// extracted by mini-css-extract-plugin
export default {"border":"about_border__9rBP0","partner":"about_partner__asNmC"};